import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import ArticleCard from "@/components/base/ArticleCard";
import Reveal from "@/components/feature/Reveal";
import { articles, featuredSlugs } from "@/mocks/melons";

export default function FeaturedDeepDives() {
  const featured = featuredSlugs
    .map((slug) => articles.find((item) => item.slug === slug))
    .filter((item): item is (typeof articles)[number] => Boolean(item));

  const lead = featured[0];
  const rest = featured.slice(1);

  return (
    <section className="w-full py-14 md:py-20">
      <Container>
        <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.22em] text-primary-600">本期深度</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              本周整理的四条完整时间线
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            每一篇都附上可核对的时间戳与原始材料片段，并单独标出目前仍无法确认的区间。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {lead ? (
            <Reveal className="lg:col-span-7">
              <ArticleCard article={lead} variant="feature" />
            </Reveal>
          ) : null}
          <div className="flex flex-col gap-6 lg:col-span-5">
            {rest.map((article, index) => (
              <Reveal key={article.slug} delay={index * 90}>
                <ArticleCard article={article} variant="standard" />
              </Reveal>
            ))}
          </div>
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部瓜田
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
}